module.exports = __webpack_public_path__ + "img/jichang.a79c7fd1.png";